export default __webpack_public_path__ + "static/media/Level3.679aa058.svg";